import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../appUtils/axiosConfig";

const initialState = {

    isLoading: false,
    error: null,
    inventories: [],
    isInventoryLoading: false,
    isActiveLoading: false,

}

export const getInventories = createAsyncThunk(
    'get_inventory_page',
    async (_, { dispatch, rejectWithValue }) => {

        try {
            dispatch(getInventoriesStart());
            const response = await axios.get(`/inventories/get_all_inventories.php`)
            if (response?.data?.status == 'success') {

                dispatch(getInventoriesSuccess(response?.data?.data))
            }


        } catch (error) {
            dispatch(getInventoriesFailure(error.response.data.message))
        }
    }
)
export const addInventory = createAsyncThunk(
    "addinventories",
    async (data, { dispatch, rejectWithValue }) => {
        try {
            dispatch(addInventoryStart());
            const response = await axios.post(`/inventories/add_inventory.php`, data);
            dispatch(addInventorySuccess(response.data?.user));
            if (response?.data?.status == 'success') {
                dispatch(getInventories())
                // SHOW_SUCCESS_NOTIFICATION("Login Successfully");
            }
            return response.data
        } catch (error) {
            dispatch(addInventoryFailure(error.response.data.message));
            // SHOW_ERROR_NOTIFICATION(error.response.data.message);
            return rejectWithValue(error.response.data.message);
        }
    }
);

export const updateInventory = createAsyncThunk(
    "addinventories",
    async ({ data }, { dispatch, rejectWithValue }) => {

        try {
            dispatch(updateInventoryStart());
            const response = await axios.post(`/inventories/update_inventory.php`, data);
            dispatch(updateInventorySuccess(response.data?.user));
            if (response?.data?.status == 'success') {
                dispatch(getInventories())
                // SHOW_SUCCESS_NOTIFICATION("Login Successfully");
            }
            return response.data
        } catch (error) {
            dispatch(updateInventoryFailure(error.response.data.message));
            // SHOW_ERROR_NOTIFICATION(error.response.data.message);
            return rejectWithValue(error.response.data.message);
        }
    }
);


const inventoriesSlice = createSlice({
    name: 'inventories',
    initialState,
    reducers: {
        getInventoriesStart(state) {
            state.isLoading = true;
            state.error = null;
        },
        getInventoriesSuccess(state, action) {

            state.inventories = action.payload;
            state.isLoading = false;
        },
        getInventoriesFailure(state, action) {
            state.inventories = null;
            state.isLoading = false;
            state.error = action.payload;

        },



        addInventoryStart(state) {
            state.isInventoryLoading = true;
            state.error = null;
        },
        addInventorySuccess(state, action) {
            state.user = action.payload;
            state.isInventoryLoading = false;
        },
        addInventoryFailure(state, action) {
            state.error = action.payload;
            state.isInventoryLoading = false;
        },

        updateInventoryStart(state) {
            state.isInventoryLoading = true;
            state.error = null;
        },
        updateInventorySuccess(state, action) {
            state.user = action.payload;
            state.isInventoryLoading = false;
        },
        updateInventoryFailure(state, action) {
            state.error = action.payload;
            state.isInventoryLoading = false;
        },

    }
})

export const { getInventoriesSuccess, getInventoriesStart, getInventoriesFailure, addInventoryStart, addInventorySuccess, addInventoryFailure, updateInventoryStart, updateInventorySuccess, updateInventoryFailure } = inventoriesSlice.actions;

export default inventoriesSlice.reducer;